import * as React from 'react';
import Button from '../../../components/Button';
import styled from '../../../styled-components';

interface CreateVSponseButtonProps extends React.HTMLProps<HTMLButtonElement> {}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
`;

const CreateVSponseButton: React.FC<CreateVSponseButtonProps> = ({ onClick }) => (
    <Wrapper>
        <Button onClick={onClick}>Create new V-Sponse</Button>
    </Wrapper>
);

export default CreateVSponseButton;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/CreateVSponseButton.tsx